import clsx from 'clsx';
import { useDeviceType } from 'hooks/use-device-type';
import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const slides = [
	{
		photoSrc: 'transformations/transformation-1.jpg',
		photoAlt: 'Transformacja 1',
	},
	{
		photoSrc: 'transformations/transformation-2.jpg',
		photoAlt: 'Transformacja 2',
	},
	{
		photoSrc: 'transformations/transformation-3.jpg',
		photoAlt: 'Transformacja 3',
	},
	{
		photoSrc: 'transformations/transformation-4.jpg',
		photoAlt: 'Transformacja 4',
	},
	{
		photoSrc: 'transformations/transformation-5.jpg',
		photoAlt: 'Transformacja 5',
	},
	{
		photoSrc: 'transformations/transformation-6.jpg',
		photoAlt: 'Transformacja 6',
	},
	{
		photoSrc: 'transformations/transformation-7.jpg',
		photoAlt: 'Transformacja 7',
	},
];

export const TransformationsSlider = () => {
	const deviceType = useDeviceType();

	const settings = {
		dots: true,
		infinite: true,
		speed: 500,
		slidesToShow: deviceType === 'monitor' ? 3 : 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 4000,
		centerMode: deviceType === 'monitor',
		centerPadding: '0px',
	};

	return (
		<div className="max-w-7xl mx-auto px-6">
			<div className="text-center mb-12">
				<span className="inline-block px-4 py-2 bg-primary-100 text-primary-700 rounded-full text-sm font-bold mb-4">
					EFEKTY
				</span>
				<h2 className="font-playfair-custom-bold text-4xl lg:text-5xl text-gray-900">
					Przemiany moich <span className="text-gradient">podopiecznych</span>
				</h2>
			</div>

			<div className="pb-8">
				<Slider {...settings}>
					{slides.map(({ photoSrc, photoAlt }, slideIndex) => (
						<div key={slideIndex} className="px-3 pb-4">
							<div
								className={clsx(
									'rounded-3xl overflow-hidden shadow-soft hover:shadow-soft-lg transition-all duration-300 hover:-translate-y-1'
								)}
							>
								<img
									src={photoSrc}
									alt={photoAlt}
									className="w-full h-auto object-cover"
								/>
							</div>
						</div>
					))}
				</Slider>
			</div>
		</div>
	);
};
